import { render, staticRenderFns } from "./weeklydppm.vue?vue&type=template&id=65015982&scoped=true&"
import script from "./weeklydppm.vue?vue&type=script&lang=js&"
export * from "./weeklydppm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65015982",
  null
  
)

export default component.exports